import { P2GBox, P2GContainer, P2GIcon, P2GText, SvgCheckCircle } from '@parcel2go/core-ui';
import { AppSurface } from '~/components/surface/app-surface';

type props = {
  title: string;
  subTitle?: string;
  sectionHeading?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  display?: StageScreenDisplay;
};

export type StageScreenDisplay = 'card' | 'default';

const Wrapper = ({ children, wrap }: { children: React.ReactNode; wrap: boolean }) => {
  return wrap ? (
    <P2GContainer maxWidth="xs">
      <AppSurface>{children}</AppSurface>
    </P2GContainer>
  ) : (
    <>{children}</>
  );
};

const StageScreen = ({ title, subTitle, children, icon, sectionHeading, display }: props) => {
  return (
    <Wrapper wrap={display === 'card'}>
      <P2GBox sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 2 }}>
        <P2GIcon palette="primary" size="lg">
          {icon || <SvgCheckCircle />}
        </P2GIcon>
        <P2GText textAlign="center" variant="h2" component="div">
          {title}
        </P2GText>
        {subTitle && (
          <P2GText textAlign="center" variant="subtitle1" component="div">
            {subTitle}
          </P2GText>
        )}
      </P2GBox>
      <P2GBox mt={4}>
        {sectionHeading && (
          <P2GBox mb={1}>
            <P2GText>
              <strong>{sectionHeading}</strong>
            </P2GText>
          </P2GBox>
        )}
        <P2GBox>{children}</P2GBox>
      </P2GBox>
    </Wrapper>
  );
};
export default StageScreen;
